// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    font-family: "GothamBold", "Helvetica Neue", Helvetica,Arial, sans-serif;
}

.container{
    display: flex;
    padding: 10px;
      padding-left: 10px;
    padding-right: 10px;

}
 
 .content{
    flex:3;
} 
 
.welcome-section {
    flex: 4;
    display: flex;
    align-items:flex-end ;
    justify-content: space-between;
    background-color:white;
}
 
.welcome-section h1{
    padding: 20px;
    font-size: 23px;
    color: #333;
    text-align: left;
}
 
.content-image{
    height: 44vh;
    width: 100%;
    display: block; 
    flex: 0;
}
 
.sidebar{
     padding-left: 20px;
     padding-bottom: 10px; 
   

    
}
 
.sidebar-section{
    margin-bottom: 0px;
      
}
.sidebar  h3 {
    
    color: white;
    background-color:#286090;
    cursor: pointer;
    padding-left: 10px;
    font-size: 15px;
    width: 250px;
    border-radius: 3px 3px 0 0;
     margin-bottom: 0px; 
     text-align: left;

}
 
.sidebar ul {
    width: 250px;
    border: solid 2px #286090;
    background-color:white; 
    border-radius:0 0 3px 3px ;
     

      list-style-type:none ;
    padding: 0;
    margin: 0;
}
.material-icons{
    padding-left: 0px;
   position: relative;
    top: 8px;
    right: 10px;
    color:#286090 ;
}
 
.sidebar ul li {
    padding-left: 10px;
    margin-bottom: 0px;
}
 
.sidebar ul li a {
    text-align: left; 
   
    margin-bottom: 5px; 

    text-decoration: none;
    font-size: 12px;
    color: #333;
    position: relative;
    right:10px;
}
 
.sidebar ul li a:hover {
    text-decoration: underline;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/home/home.component.css"],"names":[],"mappings":"AAAA;IACI,wEAAwE;AAC5E;;AAEA;IACI,aAAa;IACb,aAAa;MACX,kBAAkB;IACpB,mBAAmB;;AAEvB;;CAEC;IACG,MAAM;AACV;;AAEA;IACI,OAAO;IACP,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,cAAc;IACd,OAAO;AACX;;AAEA;KACK,kBAAkB;KAClB,oBAAoB;;;;AAIzB;;AAEA;IACI,kBAAkB;;AAEtB;AACA;;IAEI,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,0BAA0B;KACzB,kBAAkB;KAClB,gBAAgB;;AAErB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;;;MAGxB,qBAAqB;IACvB,UAAU;IACV,SAAS;AACb;AACA;IACI,iBAAiB;GAClB,kBAAkB;IACjB,QAAQ;IACR,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;;IAEhB,kBAAkB;;IAElB,qBAAqB;IACrB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,0BAA0B;AAC9B;AACA,43GAA43G","sourcesContent":[":host {\n    font-family: \"GothamBold\", \"Helvetica Neue\", Helvetica,Arial, sans-serif;\n}\n\n.container{\n    display: flex;\n    padding: 10px;\n      padding-left: 10px;\n    padding-right: 10px;\n\n}\n \n .content{\n    flex:3;\n} \n \n.welcome-section {\n    flex: 4;\n    display: flex;\n    align-items:flex-end ;\n    justify-content: space-between;\n    background-color:white;\n}\n \n.welcome-section h1{\n    padding: 20px;\n    font-size: 23px;\n    color: #333;\n    text-align: left;\n}\n \n.content-image{\n    height: 44vh;\n    width: 100%;\n    display: block; \n    flex: 0;\n}\n \n.sidebar{\n     padding-left: 20px;\n     padding-bottom: 10px; \n   \n\n    \n}\n \n.sidebar-section{\n    margin-bottom: 0px;\n      \n}\n.sidebar  h3 {\n    \n    color: white;\n    background-color:#286090;\n    cursor: pointer;\n    padding-left: 10px;\n    font-size: 15px;\n    width: 250px;\n    border-radius: 3px 3px 0 0;\n     margin-bottom: 0px; \n     text-align: left;\n\n}\n \n.sidebar ul {\n    width: 250px;\n    border: solid 2px #286090;\n    background-color:white; \n    border-radius:0 0 3px 3px ;\n     \n\n      list-style-type:none ;\n    padding: 0;\n    margin: 0;\n}\n.material-icons{\n    padding-left: 0px;\n   position: relative;\n    top: 8px;\n    right: 10px;\n    color:#286090 ;\n}\n \n.sidebar ul li {\n    padding-left: 10px;\n    margin-bottom: 0px;\n}\n \n.sidebar ul li a {\n    text-align: left; \n   \n    margin-bottom: 5px; \n\n    text-decoration: none;\n    font-size: 12px;\n    color: #333;\n    position: relative;\n    right:10px;\n}\n \n.sidebar ul li a:hover {\n    text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
